import React from "react";
import OmSymbol from "./OmSymbol";

export default function SectionTitle({ eyebrow, title, subtitle, light = false }) {
  return (
    <div className="text-center max-w-3xl mx-auto mb-16">
      {eyebrow && (
        <span
          className={`eyebrow-chip mb-4 ${
            light
              ? "bg-gold-500/15 text-gold-200 border border-gold-300/30"
              : "bg-saffron-50 text-saffron-700 border border-gold-200"
          }`}
        >
          <span className={`w-1.5 h-1.5 rounded-full ${light ? "bg-gold-300" : "bg-saffron-500"}`} />
          {eyebrow}
        </span>
      )}
      <h2
        className={`font-heading text-4xl sm:text-5xl leading-tight ${
          light ? "text-gold-100" : "text-maroon-800"
        }`}
      >
        {title}
      </h2>
      <div className="gold-divider my-6">
        <span className={`inline-flex ${light ? "text-gold-300" : "text-saffron-500"}`}><OmSymbol size={24} /></span>
      </div>
      {subtitle && (
        <p
          className={`${
            light ? "text-gold-100/85" : "text-gray-600"
          } text-lg leading-relaxed font-light`}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
}
